import Vue from 'vue'
import Vuex from 'vuex'
import city from './store/modules/city'
import game from './store/modules/game'
import message from './store/modules/message'
import notification from './store/modules/notification'
import user from './store/modules/user'
import team from './store/modules/team'
import tournament from './store/modules/tournament'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        city,
        game,
        message,
        notification,
        user,
        team,
        tournament,
    },
    strict: true,
    plugins: [],
});
